// Personal vs business (custom-domain) classification for email accounts.
//
// Hand-synced MIRROR of the backend source of truth at
// `packages/dns/src/email-domains.ts` (`@trulyinbox/dns`). apps/web doesn't
// depend on that node-only package, so the free-domain list lives here too —
// same rationale as the DNS-gate mirroring documented in
// `features/email-accounts/account-status.ts`. Keep the two lists in sync.
//
// "Personal" = mailbox on a free consumer provider the tenant doesn't control,
// so it can't publish DKIM → DKIM is not required to warm up. "Business" = a
// custom domain where DKIM is required.

export const FREE_EMAIL_DOMAINS: ReadonlySet<string> = new Set([
  // Google
  'gmail.com', 'googlemail.com',
  // Microsoft
  'outlook.com', 'outlook.co.uk', 'hotmail.com', 'hotmail.co.uk', 'live.com', 'msn.com',
  // Yahoo / AOL
  'yahoo.com', 'yahoo.co.uk', 'yahoo.co.in', 'ymail.com', 'rocketmail.com', 'aol.com',
  // Apple
  'icloud.com', 'me.com', 'mac.com',
  // Proton / GMX / others
  'proton.me', 'protonmail.com', 'pm.me', 'gmx.com', 'gmx.net', 'mail.com', 'yandex.com', 'zoho.com',
]);

/** Lower-cased domain part of an email address (`''` when malformed). */
export function domainOfEmail(email: string): string {
  return (email.split('@')[1] ?? '').trim().toLowerCase();
}

/**
 * True when the mailbox is on a free consumer provider (non-custom domain).
 * Such accounts skip the DKIM requirement entirely.
 */
export function isPersonalEmail(email: string): boolean {
  return FREE_EMAIL_DOMAINS.has(domainOfEmail(email));
}
